(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-newsletter"] && !Shopify.designMode) return;
  try {
    const restoreMenuNewsletter = () => {
    const status = document.querySelector('#MenuNewsletterForm [data-menu-newsletter-status]');
    const drawer = status?.closest('header-drawer');
    if (!drawer || !drawer.getClientRects().length) return;
    customElements.whenDefined('header-drawer').then(() => {
      const details = drawer.querySelector('details');
      const summary = details.querySelector('summary');
      details.setAttribute('open', '');
      drawer.openMenuDrawer(summary);
      status.focus();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreMenuNewsletter, { once: true });
  } else {
    restoreMenuNewsletter();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["seidler-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('seidler-card-gallery')) {
    customElements.define('seidler-card-gallery', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => this.connect());
      }

      connect() {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = window.matchMedia('(max-width: 749px)');
        const mount = () => {
          if (this.mobile.matches && !this.hasAttribute('data-ready')) this.mount(signal);
        };
        this.mobile.addEventListener('change', mount, { signal });
        mount();
        if (this.hasAttribute('data-ready') && !this.track) this.bind(signal);
      }

      mount(signal) {
        const template = this.querySelector('template');
        if (!template) return;
        this.append(template.content.cloneNode(true));
        this.setAttribute('data-ready', '');
        this.bind(signal);
      }

      bind(signal) {
        this.track = this.querySelector('.seidler-card-gallery__track');
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        this.activeIndex = 0;
        this.suppressClickUntil = 0;
        const update = () => {
          if (!this.track.clientWidth) return;
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.activeIndex = Math.max(0, Math.min(this.slides.length - 1, index));
          this.dots.forEach((dot, i) => {
            if (i === this.activeIndex) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.slides.forEach((slide, i) => {
            slide.tabIndex = i === this.activeIndex ? 0 : -1;
            if (i === this.activeIndex) slide.removeAttribute('aria-hidden');
            else slide.setAttribute('aria-hidden', 'true');
          });
        };
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(update);
        }, { signal, passive: true });
        this.dots.forEach(dot => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slide)), { signal }));
        this.track.addEventListener('keydown', event => {
          let index = this.activeIndex;
          if (event.key === 'ArrowRight') index++;
          else if (event.key === 'ArrowLeft') index--;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.slides.length - 1;
          else return;
          event.preventDefault();
          this.goTo(index);
        }, { signal });
        this.track.addEventListener('pointerdown', event => {
          this.pointerStart = { x: event.clientX, y: event.clientY };
          this.suppressClickUntil = 0;
        }, { signal, passive: true });
        this.track.addEventListener('pointerup', event => {
          if (this.pointerStart && Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 8) {
            this.suppressClickUntil = performance.now() + 350;
          }
          this.pointerStart = null;
        }, { signal, passive: true });
        this.track.addEventListener('pointercancel', () => {
          this.pointerStart = null;
          this.suppressClickUntil = performance.now() + 350;
        }, { signal, passive: true });
        this.track.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { signal, capture: true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }

      goTo(index) {
        const target = Math.max(0, Math.min(this.slides.length - 1, index));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reducedMotion ? 'instant' : 'smooth' });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.controller = null;
        this.track = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
